import axios from 'axios'
import moment from 'moment'

// const API_URL = 'https://app.ultrahealth.care/functions/calcs'
// const API_URL = 'https://dev.ultrahealth.care/functions/calcs'
// const API_URL = 'http://localhost:5000/ultracarebr/southamerica-east1/calcs'
const API_URL = 'https://southamerica-east1-ultracarebr.cloudfunctions.net/calcs'

export default {

  async fieldsAvgValidate (targetKey, params, data) {
    let sum = 0
    let qtd = 0
    let fields
    if (data && data.forms && data.forms[targetKey] && data.forms[targetKey].fields) {
      fields = data.forms[targetKey].fields
    } else {
      fields = Object.keys(params)
    }
    for (let param in params) {
      if (!fields.includes(param)) continue
      let value = params[param]
      if (value && typeof value === 'object') value = value.result
      value = parseFloat(value)
      if (value) {
        sum += value
        qtd++
      }
    }
    let avg = null
    if (qtd > 0) {
      avg = sum / qtd
    }
    let forms = {}
    if (!forms[targetKey]) forms[targetKey] = {}
    forms[targetKey].result = formatDecimal(avg)
    forms[targetKey].fields = fields
    forms[targetKey].author = 'fieldsAvgValidate'
    forms[targetKey].percentil = null
    return { forms }
  },

  async fieldsAvg (targetKey, params, data) {
    let sum = 0
    let qtd = 0
    for (let param in params) {
      let value = params[param]
      if (typeof value === 'object') value = value.result
      value = parseFloat(value)
      if (value) {
        sum += value
        qtd++
      }
    }
    let avg = null
    if (qtd > 0) {
      avg = sum / qtd
    }
    let forms = {}
    forms[targetKey] = formatDecimal(avg)
    return { forms }
  },

  async fieldsSum (targetKey, params, data) {
    let sum = 0
    for (let param in params) {
      let value = params[param]
      if (typeof value === 'object') value = value.result
      if (value === 'A') value = 2
      value = parseFloat(value)
      if (value) {
        // console.log('params: ', param, 'value: ', value)
        sum += value
      }
    }
    let forms = {}
    // console.log('sum: ', sum)
    forms[targetKey] = formatDecimal(sum)
    return { forms }
  },

  async fieldsVol (targetKey, params, data) {
    let vol = 0
    for (let param in params) {
      let value = params[param]
      if (typeof value === 'object') value = value.result
      value = parseFloat(value)
      if (value) {
        if (vol) vol *= value
        else vol = value
      }
    }
    let forms = {}
    forms[targetKey] = formatDecimal(vol * 0.52 / 1000, 2)
    return { forms }
  },

  async fieldsCopy (targetKey, params, data) {
    let value = null
    for (let param in params) {
      if (param.endsWith('.hasData')) continue
      value = params[param]
      if (typeof value === 'object') value = value.result
      if (value) {
        break
      }
    }
    let forms = {}
    forms[targetKey] = value
    return { forms }
  },

  async fieldsMax (targetKey, params, data) {
    let arr = []
    for (let param in params) {
      if (params[param]) {
        arr.push(parseFloat(params[param]))
      }
    }
    let forms = {}
    forms[targetKey] = Math.max(...arr)
    return { forms }
  },

  async trissomiaCalc (targetKey, params, data) {
    // console.log(targetKey, params)
    let forms = {}
    if (!data || !data.forms) return {}

    params.examinationDate = data.forms['gestationalAge.info.interationDate'].toISOString().substring(0, 10)

    const concepcao = data.forms['gestationalAge.info.concepcao']
    const fertilizacaoInVitro = data.forms['gestationalAge.info.fertilizacaoInVitro']
    if (concepcao === 'fertilizacao' && fertilizacaoInVitro === 'doacao') {
      params.dateBirthMother = data.forms['gestationalAge.info.dateDoadora'].toISOString().substring(0, 10)
    } else {
      params.dateBirthMother = data.forms['gestationalAge.info.dateBirthMother'].toISOString().substring(0, 10)
    }

    let base = targetKey.replace('riscoTrissomia21', '')

    try {
      const payload = { path: '/calc/trisomies/fetalmedicine/v1', params }
      let response = await axios.post(API_URL, payload)
      if (response.data) {
        forms[base + 'riscoTrissomia21'] = response.data.t21only
        forms[base + 'riscoTrissomia21Corrigido'] = response.data.t21plus
        forms[base + 'riscoTrissomia18'] = response.data.t18only
        forms[base + 'riscoTrissomia18Corrigido'] = response.data.t18plus
        forms[base + 'riscoTrissomia13'] = response.data.t13only
        forms[base + 'riscoTrissomia13Corrigido'] = response.data.t13plus
      }
    } catch (error) {
      let err = 'Falha no cálculo'
      forms[base + 'riscoTrissomia21'] = err
      forms[base + 'riscoTrissomia21Corrigido'] = err
      forms[base + 'riscoTrissomia18'] = err
      forms[base + 'riscoTrissomia18Corrigido'] = err
      forms[base + 'riscoTrissomia13'] = err
      forms[base + 'riscoTrissomia13Corrigido'] = err
      console.error(error)
    }

    return { forms }
  },
  async meanArterialPressureCalc (targetKey, params, data) {
    let forms = {}
    var pad = ((parseFloat(params['CalculatorMAP_1stRightArmDiast']) + parseFloat(params['CalculatorMAP_1stLeftArmDiast'])) / 2)
    var pas = ((parseFloat(params['CalculatorMAP_1stLeftArmSist']) + parseFloat(params['CalculatorMAP_1stRightArmSist'])) / 2)
    var firstMeasurement = ((2 * parseFloat(pad) + parseFloat(pas)) / 3)
    pad = ((parseFloat(params['CalculatorMAP_2stLeftArmDiast']) + parseFloat(params['CalculatorMAP_2stRightArmDiast'])) / 2)
    pas = ((parseFloat(params['CalculatorMAP_2stLeftArmSist']) + parseFloat(params['CalculatorMAP_2stRightArmSist'])) / 2)
    var secondMeasurement = ((2 * parseFloat(pad) + parseFloat(pas)) / 3)
    var meanArterialPressure = formatDecimal(((parseFloat(firstMeasurement) + parseFloat(secondMeasurement)) / 2), 2)
    forms[targetKey] = meanArterialPressure.toString()
    return { forms }
  },
  async preeclampsiaCalcFetalMedicine (targetKey, params, data) {
    let forms = {}
    if (!data || !data.forms) return {}
    if (!data.gestation.date) return { forms: {[targetKey]: 'Data do exame não Informado'} }
    if (!data.forms['gestationalAge.info.concepcao']) return { forms: {[targetKey]: 'Método de concepção não Informado'} }
    if (!params['CalculatorPeMom_height']) return { forms: {[targetKey]: 'Altura não Informada'} }
    if (!params['CalculatorPeMom_weight']) return { forms: {[targetKey]: 'Peso não Informado'} }
    if (!data.patient || !data.patient.birthdate) return { forms: {[targetKey]: 'Idade da paciente não Informada'} }
    if (!data.forms['1stinitialtracking.biometria.fetos.feto_1.ccn']) return { forms: {[targetKey]: 'CCN na aba Biometria Fetal não Informado'} }
    if (data.forms['1stinitialtracking.biometria.fetos.feto_1.ccn'] < 45 || data.forms['1stinitialtracking.biometria.fetos.feto_1.ccn'] > 84) return { forms: {[targetKey]: 'CCN precisa estar entre 45 e 84'} }
    if (params['CalculatorPeMom_twins'] === '2' && !data.forms['1stinitialtracking.biometria.fetos.feto_2.ccn']) return { forms: {[targetKey]: 'CCN na aba Biometria Fetal do feto 2 não Informado'} }
    if (params['CalculatorPeMom_twins'] === '2' && (data.forms['1stinitialtracking.biometria.fetos.feto_2.ccn'] < 45 || data.forms['1stinitialtracking.biometria.fetos.feto_2.ccn'] > 84)) return { forms: {[targetKey]: 'CCN do feto 2 precisa estar entre 45 e 84'} }
    if (params['CalculatorPeMom_twins'] > '2' || params['CalculatorPeMom_twins'] < '1') return { forms: {[targetKey]: 'Apenas embriões únicos ou gemelar'} }
    // Diabetes 2
    if (data.forms['1stinitialtracking.avalRiscoPreeclampsia.maeDiabeteTipo2'] === '1' && !data.forms['1stinitialtracking.avalRiscoPreeclampsia.maeDiabeteDrogas']) return { forms: {[targetKey]: '...'} }
    // Passado Obstetrico
    if (data.forms['1stinitialtracking.avalRiscoPreeclampsia.histObstetrico'] === '1' &&
    (!data.forms['1stinitialtracking.avalRiscoPreeclampsia.dataPartoAnterior'] || !data.forms['1stinitialtracking.avalRiscoPreeclampsia.preeclampsiaAnterior'] || !data.forms['1stinitialtracking.avalRiscoPreeclampsia.gestacaoAnteriorSemanas'] || !data.forms['1stinitialtracking.avalRiscoPreeclampsia.gestacaoAnteriorDias'])) return { forms: {[targetKey]: '....'} }
    // Medidas Biofisicas
    if ((data.forms['1stinitialtracking.avalRiscoPreeclampsia.1stLeftArmSist'] || data.forms['1stinitialtracking.avalRiscoPreeclampsia.1stRightArmSist'] || data.forms['1stinitialtracking.avalRiscoPreeclampsia.1stLeftArmDiast'] || data.forms['1stinitialtracking.avalRiscoPreeclampsia.1stRightArmDiast'] || data.forms['1stinitialtracking.avalRiscoPreeclampsia.2stLeftArmSist'] || data.forms['1stinitialtracking.avalRiscoPreeclampsia.2stRightArmSist'] || data.forms['1stinitialtracking.avalRiscoPreeclampsia.2stLeftArmDiast'] || data.forms['1stinitialtracking.avalRiscoPreeclampsia.2stRightArmDiast']) && !data.forms['1stinitialtracking.avalRiscoPreeclampsia.meanArterialPressure']) return { forms: {[targetKey]: '...'} }
    if (data.forms['1stinitialtracking.avalRiscoPreeclampsia.meanArterialPressure'] && !data.forms['1stinitialtracking.avalRiscoPreeclampsia.dateOfMeasurement']) return { forms: {[targetKey]: '...'} }
    if (data.forms['1stinitialtracking.biometria.piUterinaMedia']) params['CalculatorPeMom_meanUterineArteryPi'] = data.forms['1stinitialtracking.biometria.piUterinaMedia']
    if (params['CalculatorPeMom_meanUterineArteryPi'] && !params['CalculatorPeMom_dateOfMeasurement']) delete params['CalculatorPeMom_meanUterineArteryPi']
    if (params['CalculatorPeMom_meanUterineArteryPi']) params['CalculatorPeMom_meanUterineArteryPi'] = (params['CalculatorPeMom_meanUterineArteryPi']).toString()
    if (data.forms['1stinitialtracking.avalRiscoPreeclampsia.dateOfMeasurement'] && data.forms['1stinitialtracking.avalRiscoPreeclampsia.dateOfMeasurement'] > data.forms['gestationalAge.info.interationDate']) return { forms: {[targetKey]: 'Data da medição maior que a do exame'} }
    // Medidas Bioquimicas
    if ((data.forms['1stinitialtracking.avalRiscoPreeclampsia.includesSerumPLGF'] && data.forms['1stinitialtracking.avalRiscoPreeclampsia.includesSerumPLGF'] !== '0') && !data.forms['1stinitialtracking.avalRiscoPreeclampsia.dateOfBiochemicalMeasurement']) return { forms: {[targetKey]: '....'} }
    if ((data.forms['1stinitialtracking.avalRiscoPreeclampsia.includesSerumPAPPA'] && data.forms['1stinitialtracking.avalRiscoPreeclampsia.includesSerumPAPPA'] !== '0') && !data.forms['1stinitialtracking.avalRiscoPreeclampsia.dateOfBiochemicalMeasurement']) return { forms: {[targetKey]: '....'} }
    // Idioma
    if (!params['Translate']) params['Translate'] = '0'
    const payload = {
      ...params
    }
    // Altura
    // if (params['CalculatorPeMom_height'] < 120 || params['CalculatorPeMom_height'] > 210) return { forms: {[targetKey]: 'Altura precisa estar entre 120cm e 210cm'} }

    // Data do exame
    payload['CalculatorPeMom_ga_at'] = params['CalculatorPeMom_ga_at'].toISOString().substring(0, 10)

    // Data de nascimento da mãe
    payload['CalculatorPeMom_dob'] = params['CalculatorPeMom_dob'].toISOString().substring(0, 10)

    // Data do parto anterior
    if (params['CalculatorPeMom_previous_delivered_at'] != null) payload['CalculatorPeMom_previous_delivered_at'] = params['CalculatorPeMom_previous_delivered_at'].toISOString().substring(0, 10)

    // Data de medição
    if (params['CalculatorPeMom_dateOfMeasurement'] != null) payload['CalculatorPeMom_dateOfMeasurement'] = params['CalculatorPeMom_dateOfMeasurement'].toISOString().substring(0, 10)

    // Data de medição
    if (params['CalculatorPeMom_dateOfBiochemicalMeasurement'] != null) payload['CalculatorPeMom_dateOfBiochemicalMeasurement'] = params['CalculatorPeMom_dateOfBiochemicalMeasurement'].toISOString().substring(0, 10)

    // Embriões
    if (params['CalculatorPeMom_twins'] === '2') {
      if (params['CalculatorPeMom_sacs'] === '1') {
        payload['CalculatorPeMom_twins'] = '2'
      } else {
        payload['CalculatorPeMom_twins'] = '3'
      }
      payload['CalculatorPeMom_crl2'] = data.forms['1stinitialtracking.biometria.fetos.feto_2.ccn']
    }

    // Retira campos que não fazem parte do payload
    delete payload['CalculatorPeMom_twins_chorionic']
    delete payload['CalculatorPeMom_sacs']

    // Corionicidade
    if (params['CalculatorPeMom_twins'] > '1') {
      let chorionic = params['CalculatorPeMom_twins_chorionic']
      if (!chorionic) {
        // Erro: Especificar a corionicidade
      } else {
        // Monocoriônico
        if (chorionic === '1') payload['CalculatorPeMom_twins'] = '2'
        // Dicoriônico
        else if (chorionic === '2') payload['CalculatorPeMom_twins'] = '3'
        else {
          // Cálculo não suporta Tricoriônico
        }
      }
    }
    // Método de concepção
    const conception = params['CalculatorPeMom_conception']
    if (conception === 'espontanea') payload['CalculatorPeMom_conception'] = '1'
    else if (conception === 'inducao') payload['CalculatorPeMom_conception'] = '2'
    else if (conception === 'fertilizacao') payload['CalculatorPeMom_conception'] = '3'

    let base = targetKey.replace('riscoPreeclampsia', '')
    try {
      const data = { path: '/calc/preeclampsiatrimester/fetalmedicine/v1', params: payload }
      let response = await axios.post(API_URL, data)
      if (response.data) {
        if (response.data['erroneous-input']) {
          forms[base + 'riscoPreeclampsia'] = ``
          forms[base + 'riscoPreeclampsiaText'] = response.data['erroneous-input']
          forms[base + 'riskOptional'] = ``
          forms[base + 'biochemicalMeasurementText'] = ``
        } else {
          forms[base + 'riscoPreeclampsia'] = `${response.data['history-only-week']} ${response.data['history-only-probaby']}`
          if (response.data['history-plus-map-probaby']) forms[base + 'riskOptional'] = `${response.data['history-plus-map-week']} ${response.data['history-plus-map-probaby']}`
          else forms[base + 'riskOptional'] = ``
          forms[base + 'riscoPreeclampsiaText'] = `${response.data['recommendation-title']} ${response.data['recommendation-body']}`
          if (response.data['biochemical-measurements']) forms[base + 'biochemicalMeasurementText'] = response.data['biochemical-measurements']
        }
      }
    } catch (error) {
      let err = 'Falha no cálculo'
      forms[base + 'riscoPreeclampsia'] = err
      forms[base + 'riskOptional'] = err
      console.error(error)
    }

    return { forms }
  },
  async preeclampsiaTrimesterCalcFetalMedicine (targetKey, params, data) {
    let forms = {}
    if (!data || !data.forms) return {}
    if (!data.gestation.date) return { forms: {[targetKey]: 'Data do exame não Informado'} }
    if (!data.forms['gestationalAge.info.concepcao']) return { forms: {[targetKey]: 'Método de concepção não Informado'} }
    if (!params['CalculatorPeMom_height']) return { forms: {[targetKey]: 'Altura não Informada'} }
    if (!params['CalculatorPeMom_weight']) return { forms: {[targetKey]: 'Peso não Informado'} }
    if (!data.patient || !data.patient.birthdate) return { forms: {[targetKey]: 'Idade da paciente não Informada'} }
    if (params['CalculatorPeMom_twins'] > '2' || params['CalculatorPeMom_twins'] < '1') return { forms: {[targetKey]: 'Apenas embriões únicos ou gemelar'} }
    // Diabetes 2
    if (data.forms['2ndand3rdquarter.avalRiscoPreeclampsia.maeDiabeteTipo2'] === '1' && !data.forms['2ndand3rdquarter.avalRiscoPreeclampsia.maeDiabeteDrogas']) return { forms: {[targetKey]: '...'} }
    // Passado Obstetrico
    if (data.forms['2ndand3rdquarter.avalRiscoPreeclampsia.histObstetrico'] === '1' &&
    (!data.forms['2ndand3rdquarter.avalRiscoPreeclampsia.dataPartoAnterior'] || !data.forms['2ndand3rdquarter.avalRiscoPreeclampsia.preeclampsiaAnterior'] || !data.forms['2ndand3rdquarter.avalRiscoPreeclampsia.gestacaoAnteriorSemanas'] || !data.forms['2ndand3rdquarter.avalRiscoPreeclampsia.gestacaoAnteriorDias'])) return { forms: {[targetKey]: '....'} }
    // Medidas Biofisicas
    if ((data.forms['2ndand3rdquarter.avalRiscoPreeclampsia.1stLeftArmSist'] || data.forms['2ndand3rdquarter.avalRiscoPreeclampsia.1stRightArmSist'] || data.forms['2ndand3rdquarter.avalRiscoPreeclampsia.1stLeftArmDiast'] || data.forms['2ndand3rdquarter.avalRiscoPreeclampsia.1stRightArmDiast'] || data.forms['2ndand3rdquarter.avalRiscoPreeclampsia.2stLeftArmSist'] || data.forms['2ndand3rdquarter.avalRiscoPreeclampsia.2stRightArmSist'] || data.forms['2ndand3rdquarter.avalRiscoPreeclampsia.2stLeftArmDiast'] || data.forms['2ndand3rdquarter.avalRiscoPreeclampsia.2stRightArmDiast']) && !data.forms['2ndand3rdquarter.avalRiscoPreeclampsia.meanArterialPressure']) return { forms: {[targetKey]: '...'} }
    if (data.forms['2ndand3rdquarter.avalRiscoPreeclampsia.meanArterialPressure'] && !data.forms['2ndand3rdquarter.avalRiscoPreeclampsia.dateOfMeasurement']) return { forms: {[targetKey]: '...'} }
    if (data.forms['2ndand3rdquarter.biometria.piUterinaMedia'] && !data.forms['2ndand3rdquarter.avalRiscoPreeclampsia.dateOfMeasurement']) delete params['CalculatorPeMom_meanUterineArteryPi']
    if (params['CalculatorPeMom_meanUterineArteryPi']) params['CalculatorPeMom_meanUterineArteryPi'] = (params['CalculatorPeMom_meanUterineArteryPi']).toString()
    if (data.forms['2ndand3rdquarter.avalRiscoPreeclampsia.dateOfMeasurement'] && data.forms['2ndand3rdquarter.avalRiscoPreeclampsia.dateOfMeasurement'] > data.forms['gestationalAge.info.interationDate']) return { forms: {[targetKey]: 'Data da medição maior que a do exame'} }
    // Medidas Bioquimicas
    if ((data.forms['2ndand3rdquarter.avalRiscoPreeclampsia.includesSerumPLGF'] && data.forms['2ndand3rdquarter.avalRiscoPreeclampsia.includesSerumPLGF'] !== '0') && !data.forms['2ndand3rdquarter.avalRiscoPreeclampsia.dateOfBiochemicalMeasurement']) return { forms: {[targetKey]: '....'} }
    if ((data.forms['2ndand3rdquarter.avalRiscoPreeclampsia.includesSerumPAPPA'] && data.forms['2ndand3rdquarter.avalRiscoPreeclampsia.includesSerumPAPPA'] !== '0') && !data.forms['2ndand3rdquarter.avalRiscoPreeclampsia.dateOfBiochemicalMeasurement']) return { forms: {[targetKey]: '....'} }
    const payload = {
      ...params
    }
    // Idioma
    if (!params['Translate']) params['Translate'] = '0'
    // Idade Gestacional em dias
    payload['gestationalAgeInDays'] = data.forms['gestationalAge.info.date'] ? data.forms['gestationalAge.info.calculada'].toString() : ''

    // Data do exame
    payload['CalculatorPeMom_ga_at'] = params['CalculatorPeMom_ga_at'].toISOString().substring(0, 10)
    // Data de nascimento da mãe
    payload['CalculatorPeMom_dob'] = params['CalculatorPeMom_dob'].toISOString().substring(0, 10)

    // Data do parto anterior
    if (params['CalculatorPeMom_previous_delivered_at'] != null) payload['CalculatorPeMom_previous_delivered_at'] = params['CalculatorPeMom_previous_delivered_at'].toISOString().substring(0, 10)

    // Data de medição
    if (params['CalculatorPeMom_dateOfMeasurement'] != null) payload['CalculatorPeMom_dateOfMeasurement'] = params['CalculatorPeMom_dateOfMeasurement'].toISOString().substring(0, 10)

    // Data de medição
    if (params['CalculatorPeMom_dateOfBiochemicalMeasurement'] != null) payload['CalculatorPeMom_dateOfBiochemicalMeasurement'] = params['CalculatorPeMom_dateOfBiochemicalMeasurement'].toISOString().substring(0, 10)

    // Embriões
    if (params['CalculatorPeMom_twins'] === '2') {
      if (params['CalculatorPeMom_sacs'] === '1') {
        payload['CalculatorPeMom_twins'] = '2'
      } else {
        payload['CalculatorPeMom_twins'] = '3'
      }
      payload['CalculatorPeMom_crl2'] = data.forms['2ndand3rdquarter.biometria.fetos.feto_2.ccn']
    }

    // Retira campos que não fazem parte do payload
    delete payload['CalculatorPeMom_twins_chorionic']
    delete payload['CalculatorPeMom_sacs']

    // Corionicidade
    if (params['CalculatorPeMom_twins'] > '1') {
      let chorionic = params['CalculatorPeMom_twins_chorionic']
      if (!chorionic) {
        // Erro: Especificar a corionicidade
      } else {
        // Monocoriônico
        if (chorionic === '1') payload['CalculatorPeMom_twins'] = '2'
        // Dicoriônico
        else if (chorionic === '2') payload['CalculatorPeMom_twins'] = '3'
        else {
          // Cálculo não suporta Tricoriônico
        }
      }
    }
    // Método de concepção
    const conception = params['CalculatorPeMom_conception']
    if (conception === 'espontanea') payload['CalculatorPeMom_conception'] = '1'
    else if (conception === 'inducao') payload['CalculatorPeMom_conception'] = '2'
    else if (conception === 'fertilizacao') payload['CalculatorPeMom_conception'] = '3'
    let base = targetKey.replace('riscoPreeclampsia', '')
    try {
      const data = { path: '/calc/preeclampsiatrimester/fetalmedicine/v1', params: payload }
      let response = await axios.post(API_URL, data)
      if (response.data) {
        if (response.data['erroneous-input']) {
          forms[base + 'riscoPreeclampsia'] = ``
          forms[base + 'riscoPreeclampsiaText'] = response.data['erroneous-input']
          forms[base + 'riskOptional'] = ``
          forms[base + 'biochemicalMeasurementText'] = ``
        } else {
          forms[base + 'riscoPreeclampsia'] = `${response.data['history-only-week']} ${response.data['history-only-probaby']}`
          if (response.data['history-plus-map-probaby']) forms[base + 'riskOptional'] = `${response.data['history-plus-map-week']} ${response.data['history-plus-map-probaby']}`
          else forms[base + 'riskOptional'] = ``
          if (response.data['history-only-week2'] && response.data['history-only-probaby2']) forms[base + 'riscoPreeclampsia'] += ` e ` + `${response.data['history-only-week2']} ${response.data['history-only-probaby2']}`
          if (response.data['history-plus-map-probaby2']) forms[base + 'riskOptional'] += ` e ` + `${response.data['history-plus-map-week2']} ${response.data['history-plus-map-probaby2']}`
          forms[base + 'riscoPreeclampsiaText'] = `${response.data['recommendation-title']} ${response.data['recommendation-body']}`
          if (response.data['biochemical-measurements']) forms[base + 'biochemicalMeasurementText'] = `${response.data['biochemical-measurements']}`
        }
      }
    } catch (error) {
      let err = 'Falha no cálculo'
      forms[base + 'riscoPreeclampsia'] = err
      forms[base + 'riskOptional'] = err
      console.error(error)
    }

    return { forms }
  },

  async preeclampsiaCalcBarcelona (targetKey, params, data) {
    if (!data || !data.forms) return {}
    let forms = {}
    if (!data.patient || !data.patient.height) return { forms: {[targetKey]: 'Altura não Informada'} }
    if (!data.patient.weight) return { forms: {[targetKey]: 'Peso não Informado'} }
    if (!data.patient.birthdate) return { forms: {[targetKey]: 'Idade da paciente não Informada'} }
    if (!data.forms['1stinitialtracking.biometria.fetos.feto_1.ccn']) return { forms: {[targetKey]: 'CCN na aba Biometria Fetal não Informado'} }

    params.rpEad = moment().diff(params.rpEad, 'years').toString()
    let base = targetKey.replace('riscoPreeclampsiaBarcelona', '')
    try {
      const data = { path: '/calc/preeclampsia/medicinefetalbarcelona/v1', params }
      let response = await axios.post(API_URL, data)
      if (response.data) {
        if (!response.data['error']) forms[base + 'riscoPreeclampsiaBarcelona'] = `1/${response.data['early']}`
        else forms[base + 'riscoPreeclampsiaBarcelona'] = `${response.data['error']}`
      }
    } catch (error) {
      let err = 'Falha no cálculo'
      forms[base + 'riscoPreeclampsiaBarcelona'] = err
      console.error(error)
    }

    return { forms }
  },

  async anemiaCalcBarcelona (targetKey, params, data) {
    if (!data || !data.forms) return {}

    let weeks = Math.floor(params['CalculatorAnemia_weeks_and_days'] / 7)
    let days = params['CalculatorAnemia_weeks_and_days'] % 7
    params['CalculatorAnemia_weeks'] = weeks.toString()
    params['CalculatorAnemia_days'] = days.toString()

    let forms = {}
    let base = targetKey.replace('expectedPSV', '')

    // Verifica se Velocidade Sistólica esta dentro dos valores possíveis
    if (params['CalculatorAnemia_velocSistolica'] <= 10 || params['CalculatorAnemia_velocSistolica'] > 150) {
      forms[targetKey] = ''
      forms[base + 'anemiaMom'] = ''
      forms[base + 'anemiaLevel'] = 'Erro: Velocidade Sistólica fora do intervalo 11 e 150'
      return { forms }
    }
    // Verifica se as semanas de gestação esta dentro dos valores possíveis
    if (weeks <= 14 || weeks > 44) {
      forms[targetKey] = ''
      forms[base + 'anemiaMom'] = ''
      forms[base + 'anemiaLevel'] = 'Erro: Semanas fora do intervalo 14 e 44'
      return { forms }
    }

    try {
      let response = await axios.post(`https://ultracarebr.appspot.com/calc/anemia/medicinefetalbarcelona/v1`, params)
      if (response.data) {
        if (!response.data['error']) {
          forms[base + 'expectedPSV'] = `${response.data['PSV']}`
          forms[base + 'anemiaMom'] = `${response.data['MoM']}`
          forms[base + 'anemiaLevel'] = `${response.data['anemiaLevel']}`
        } else forms[base + 'expectedPSV'] = `${response.data['error']}`
      }
    } catch (error) {
      let err = 'Falha no cálculo'
      forms[base + 'expectedPSV'] = err
      console.error(error)
    }
    return { forms }
  },

  async anemiaVolumeToTransfuseCalcBarcelona (targetKey, params, data) {
    if (!data || !data.forms) return {}
    let forms = {}

    if (params['CalculatorAnemiaVolumeToTransfuse_weeks'] != null) params['CalculatorAnemiaVolumeToTransfuse_weeks'] = (params['CalculatorAnemiaVolumeToTransfuse_weeks']).toString()
    if (params['CalculatorAnemiaVolumeToTransfuse_days'] != null) params['CalculatorAnemiaVolumeToTransfuse_days'] = (params['CalculatorAnemiaVolumeToTransfuse_days']).toString()

    let base = targetKey.replace('volumeToTransfuse', '')

    try {
      let response = await axios.post(`https://ultracarebr.appspot.com/calc/anemiaVolumeToTransfuse/medicinefetalbarcelona/v1`, params)
      if (response.data) {
        if (!response.data['error']) forms[base + 'volumeToTransfuse'] = `${response.data['volumeToTransfuse']}`
        else forms[base + 'volumeToTransfuse'] = `${response.data['error']}`
      }
    } catch (error) {
      let err = 'Falha no cálculo'
      forms[base + 'volumeToTransfuse'] = err
      console.error(error)
    }
    return { forms }
  },

  async riskPremature (targetKey, params, data) {
    let forms = {}
    if (!data || !data.forms) return {}

    function getNumber (arr, week) {
      return parseFloat(arr[week].replace(',', '.'))
    }

    const previousRisk = {
      '<28': '434',
      '28-30': '416',
      '31-33': '175',
      '34-36': '34'
    }

    const previousPrematureTable = {
      'nulipara': {'<28': '1,07', '28-30': '1', '31-33': '0,98', '34-36': '1,03'},
      '16-23': {'<28': '4,42', '28-30': '1,65', '31-33': '1,64', '34-36': '1,7'},
      '24-33': {'<28': '1,99', '28-30': '3,67', '31-33': '3,91', '34-36': '2,22'},
      '34-36': {'<28': '0,97', '28-30': '1,93', '31-33': '2,63', '34-36': '2,84'},
      '>=37': {'<28': '0,58', '28-30': '0,62', '31-33': '0,63', '34-36': '0,74'}
    }

    const cervicalTable = {
      '0': {'<28': '745,29', '28-30': '74,29', '31-33': '44,22', '34-36': '99,36'},
      '1': {'<28': '745,29', '28-30': '74,29', '31-33': '44,22', '34-36': '99,36'},
      '2': {'<28': '409,86', '28-30': '56,1', '31-33': '34,78', '34-36': '58,12'},
      '3': {'<28': '258,41', '28-30': '48,75', '31-33': '30,84', '34-36': '35,82'},
      '4': {'<28': '172,11', '28-30': '42,36', '31-33': '27,35', '34-36': '24,6'},
      '5': {'<28': '119,19', '28-30': '36,81', '31-33': '24,26', '34-36': '18,1'},
      '6': {'<28': '85,02', '28-30': '31,99', '31-33': '21,51', '34-36': '13,96'},
      '7': {'<28': '62,08', '28-30': '27,8', '31-33': '19,08', '34-36': '11,15'},
      '8': {'<28': '46,2', '28-30': '24,16', '31-33': '16,92', '34-36': '9,15'},
      '9': {'<28': '34,94', '28-30': '20,99', '31-33': '15,01', '34-36': '7,66'},
      '10': {'<28': '26,79', '28-30': '18,24', '31-33': '13,31', '34-36': '6,53'},
      '11': {'<28': '20,78', '28-30': '15,85', '31-33': '11,8', '34-36': '5,64'},
      '12': {'<28': '16,29', '28-30': '13,77', '31-33': '10,47', '34-36': '4,93'},
      '13': {'<28': '12,89', '28-30': '11,97', '31-33': '9,28', '34-36': '4,35'},
      '14': {'<28': '10,28', '28-30': '10,4', '31-33': '8,23', '34-36': '3,87'},
      '15': {'<28': '8,26', '28-30': '9,04', '31-33': '7,3', '34-36': '3,47'},
      '16': {'<28': '6,68', '28-30': '7,85', '31-33': '6,48', '34-36': '3,14'},
      '17': {'<28': '5,44', '28-30': '6,82', '31-33': '5,74', '34-36': '2,85'},
      '18': {'<28': '4,45', '28-30': '5,93', '31-33': '5,09', '34-36': '2,6'},
      '19': {'<28': '3,66', '28-30': '5,15', '31-33': '4,52', '34-36': '2,39'},
      '20': {'<28': '3,03', '28-30': '4,48', '31-33': '4,01', '34-36': '2,2'},
      '21': {'<28': '2,52', '28-30': '3,89', '31-33': '3,55', '34-36': '2,03'},
      '22': {'<28': '2,1', '28-30': '3,38', '31-33': '3,15', '34-36': '1,89'},
      '23': {'<28': '1,76', '28-30': '2,94', '31-33': '2,79', '34-36': '1,76'},
      '24': {'<28': '1,48', '28-30': '2,55', '31-33': '2,48', '34-36': '1,64'},
      '25': {'<28': '1,25', '28-30': '2,22', '31-33': '2,2', '34-36': '1,53'},
      '26': {'<28': '1,05', '28-30': '1,93', '31-33': '1,95', '34-36': '1,44'},
      '27': {'<28': '0,89', '28-30': '1,68', '31-33': '1,73', '34-36': '1,35'},
      '28': {'<28': '0,76', '28-30': '1,46', '31-33': '1,53', '34-36': '1,28'},
      '29': {'<28': '0,65', '28-30': '1,27', '31-33': '1,36', '34-36': '1,21'},
      '30': {'<28': '0,56', '28-30': '1,1', '31-33': '1,21', '34-36': '1,14'},
      '31': {'<28': '0,48', '28-30': '0,96', '31-33': '1,07', '34-36': '1,08'},
      '32': {'<28': '0,41', '28-30': '0,83', '31-33': '0,95', '34-36': '1,03'},
      '33': {'<28': '0,35', '28-30': '0,72', '31-33': '0,84', '34-36': '0,98'},
      '34': {'<28': '0,31', '28-30': '0,63', '31-33': '0,75', '34-36': '0,93'},
      '35': {'<28': '0,26', '28-30': '0,54', '31-33': '0,66', '34-36': '0,89'},
      '36': {'<28': '0,23', '28-30': '0,47', '31-33': '0,59', '34-36': '0,85'},
      '37': {'<28': '0,2', '28-30': '0,41', '31-33': '0,52', '34-36': '0,81'},
      '38': {'<28': '0,17', '28-30': '0,36', '31-33': '0,46', '34-36': '0,78'},
      '39': {'<28': '0,15', '28-30': '0,31', '31-33': '0,41', '34-36': '0,74'},
      '40': {'<28': '0,13', '28-30': '0,27', '31-33': '0,36', '34-36': '0,71'},
      '41': {'<28': '0,12', '28-30': '0,23', '31-33': '0,32', '34-36': '0,68'},
      '42': {'<28': '0,1', '28-30': '0,2', '31-33': '0,29', '34-36': '0,66'},
      '43': {'<28': '0,09', '28-30': '0,18', '31-33': '0,25', '34-36': '0,63'},
      '44': {'<28': '0,08', '28-30': '0,15', '31-33': '0,22', '34-36': '0,61'},
      '45': {'<28': '0,07', '28-30': '0,13', '31-33': '0,2', '34-36': '0,59'},
      '46': {'<28': '0,06', '28-30': '0,12', '31-33': '0,18', '34-36': '0,57'},
      '47': {'<28': '0,05', '28-30': '0,1', '31-33': '0,16', '34-36': '0,55'},
      '48': {'<28': '0,05', '28-30': '0,09', '31-33': '0,14', '34-36': '0,53'},
      '49': {'<28': '0,04', '28-30': '0,08', '31-33': '0,12', '34-36': '0,51'},
      '50': {'<28': '0,04', '28-30': '0,07', '31-33': '0,11', '34-36': '0,49'}
    }

    const previous = data.forms['riskprematurebirth.avaliacao.prematuroAnterior']
    const cervical = data.forms['riskprematurebirth.avaliacao.cervical']

    let cervicalNum = parseFloat(cervical)
    if (isNaN(cervicalNum) || cervicalNum < 0 || cervicalNum > 50) {
      forms['riskprematurebirth.avaliacao.risco28'] = ''
      forms['riskprematurebirth.avaliacao.risco30'] = ''
      forms['riskprematurebirth.avaliacao.risco33'] = ''
      forms['riskprematurebirth.avaliacao.risco36'] = ''
      return { forms }
    }
    cervicalNum = Math.round(cervicalNum)
    const previousRow = previousPrematureTable[previous]
    const cervicalRow = cervicalTable[cervicalNum + '']

    let values = {}

    for (let week in cervicalRow) {
      let ratio = getNumber(previousRow, week) * getNumber(cervicalRow, week)
      let prev = getNumber(previousRisk, week)
      let posterior = Math.round(prev / ratio)
      values[week] = { prev, ratio, posterior }
    }

    // TODO: CRIAR FILTRO
    forms['riskprematurebirth.avaliacao.risco28'] = `1 em ${values['<28'].posterior}`
    forms['riskprematurebirth.avaliacao.risco30'] = `1 em ${values['28-30'].posterior}`
    forms['riskprematurebirth.avaliacao.risco33'] = `1 em ${values['31-33'].posterior}`
    forms['riskprematurebirth.avaliacao.risco36'] = `1 em ${values['34-36'].posterior}`

    return { forms }
  }
}

/**
 * Arredonda um valor com as casas decimais informadas
 * @param value Valor a ser arredondado
 * @param precision Quantidade de casas decimais
 * @returns {number} Valor arredondado
 */
function formatDecimal (value, precision = 2) {
  if (!value) return null
  let n = Math.pow(10, precision)
  return Math.round(value * n) / n
}



// WEBPACK FOOTER //
// ./src/api/formCustomFormulas.js